import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    uid: '',
    choices: [],      //保存各题号及其对应的选项
    scorePerQues: 0,  //
    score: 0,
    cat_score1: 0,
    cat_score2: 0,
    cat_score3: 0,
    emo1: 0,
    emo2: 0,
    emo3: 0,
  },
  mutations: {
    recordUid(state,uid){
      state.uid = uid
    },
    updateRecord(state, choice) {
      var flag = false
      if (state.choices.length === 0) {
        state.choices.push(choice)
        flag = true
        return true
      }
      state.choices.forEach(item => {
        if (item.quesIndex === choice.quesIndex) {
          item.choiceIndex = choice.choiceIndex
          item.correctness = choice.correctness
          item.val = choice.val
          item.faceKey = choice.faceKey
          item.faceVal = choice.faceVal
          flag = true
          return true
        }
      })
      if (!flag) {
        state.choices.push(choice)
        return true
      }
      return false
    },
    //删除清空choices
    deleteRecord(state) {
      state.choices = []
    },
    getScore(state) {

      state.choices.forEach(item => {
        if (item.correctness === true) {
          state.score += state.scorePerQues
        }
      })
    },
    //计算每一项得分
    calScores(state){
      state.score = 0;
      state.cat_score1 = 0;
      state.cat_score2 = 0;
      state.cat_score3 = 0;
      state.choices.forEach(item => {
        state.score += item.choiceIndex*2;
        if (item.correctness === '0') {
          state.cat_score1 += item.choiceIndex*2
        }
        if (item.correctness === '1') {
          state.cat_score2 += item.choiceIndex*2
        }
        if (item.correctness === '2') {
          state.cat_score3 += item.choiceIndex*2
        }
      })
    },
    //重置state中的所有值，重新答题的时候触发
    resetStore(state) {
      state.choices = []
      state.scorePerQues = 0
      state.score = 0
      state.cat_score1 = 0
      state.cat_score2 = 0
      state.cat_score3 = 0
    }
  },
  actions: {}
})
